import axios from 'axios';
import { links } from './links';

const api = axios.create({
  baseURL: links.baseURL,
});

export default api;
